import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import ItemBox from '../../react/container/item-box';
import * as _ from '../const';
const ItemListFileName = `${ITEM_LIST}?${_.CACHEBUSTER}`;
/**
 * スライド要素の初期化
 */
const initItemSlide = (id, itemData) => {
    const targetEl = document.getElementById(id);
    if (targetEl) {
        ReactDOM.render(React.createElement(ItemBox, { itemList: itemData }), targetEl);
    }
};
/**
 * 実行
 */
// 商品一覧データの取得
axios.get(ItemListFileName).then(res => {
    Object.keys(res.data).forEach(key => {
        // スライド要素の初期化
        initItemSlide(key, res.data[key]);
    });
});
